import { forwardRef } from 'react';

import { Radio as MantineRadio, RadioProps } from '@mantine/core';

import { useMergeClassNames } from '../../utils';

import { RadioOverrideClassNames, varsResolver } from './Radio.styles';

const Radio = forwardRef<HTMLInputElement, RadioProps>((params, ref) => {
  const mergedClassNames = useMergeClassNames({
    classNames: [RadioOverrideClassNames(undefined, params), params.classNames]
  });

  return (
    <MantineRadio
      {...params}
      vars={varsResolver}
      classNames={mergedClassNames}
      ref={ref}
    />
  );
});

export { Radio };
export type { RadioProps };
